export const SET_LOADING = 'SET_LOADING';
export const SET_LOCALE = 'SET_LOCALE';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_GLOBAL_CONFIG = 'SET_GLOBAL_CONFIG';
export const SET_MODULE = 'SET_MODULE';
export const SET_MODULE_NAME = 'SET_MODULE_NAME';
export const SET_APPLICATION_CODE = 'SET_APPLICATION_CODE';
export const SET_PANEL = 'SET_PANEL';
export const TOC_SET_SELECTED = 'TOC:SET_SELECTED';
export const SET_CUSTOM_SETTINGS_MODULE = 'SET_CUSTOM_SETTINGS_MODULE';
export const SET_USER_FEATURE_MAP = 'SET_USER_FEATURE_MAP';
export const BREADCRUMB_SET = 'BREADCRUMB_SET';
export const NAVIGATION_SET_ROUTE = 'NAVIGATION_SET_ROUTE';

export const SET_LOADING_MAP = 'SET_LOADING_MAP';
export const SET_ACTION_MAP = 'SET_ACTION_MAP';
export const SET_CONFIG_MAP = 'SET_CONFIG_MAP';
export const SET_VIEW_PROJECTION_MAP = 'SET_VIEW_PROJECTION_MAP';

export const SET_BROADCASTING_ENABLED = 'SET_BROADCASTING_ENABLED';
export const SET_BROADCASTING_STATE = 'SET_BROADCASTING_STATE';

export const SET_ACTION = "SET_ACTION";

import {
    CATALOG_CLOSE,
    CATALOG_RECORD_LIST_LOADED,
    CATALOG_RECORD_LIST_LOAD_ERROR,
    CATALOG_CHANGE_SELECTED_SERVICE,
    CATALOG_ADD_CATALOG_SERVICE,
    CATALOG_DELETE_CATALOG_SERVICE,
    CATALOG_CHANGE_CATALOG_MODE,
    CATALOG_INITED,
    CATALOG_SET_LOADING,
    CATALOG_SAVING_SERVICE,
    CATALOG_CHANGE_TEXT,
    CATALOG_TEXT_SEARCH,
    CATALOG_ADD_LAYER_FROM_CATALOGS,
} from '@/components/maps/shared/catalog/CatalogActions';

import {
    LAYERDOWNLOAD_FORMAT_OPTIONS_FETCH,
    LAYERDOWNLOAD_FORMAT_OPTIONS_UPDATE,
} from '@/components/maps/shared/layer/LayerDownloadActions';

import {
    IDENTIFY_SET_LOADING,
    IDENTIFY_CHANGE_PAGE,
    IDENTIFY_NEW_REQUEST,
    IDENTIFY_PURGE_RESULTS,
    IDENTIFY_ERROR_FEATURE_INFO,
    IDENTIFY_EXCEPTIONS_FEATURE_INFO,
    IDENTIFY_LOAD_FEATURE_INFO,
} from '@/components/maps/shared/identify/IdentifyActions';

import {
    FEATURE_VIEWER_CLOSE,
    FEATURE_VIEWER_SET_LOADING,
    FEATURE_VIEWER_LOADED,
    FEATURE_VIEWER_LOAD_ERROR,
} from '@/app/shared/components/featureviewer/FeatureViewerActions';

import {
    FEEDBACKOPTIONS_INITIATE,
    FEEDBACKOPTIONS_FINISHED,
} from '@/components/maps/shared/feedbackoptions/FeedbackOptionsActions';

export {
    CATALOG_CLOSE,
    CATALOG_RECORD_LIST_LOADED,
    CATALOG_RECORD_LIST_LOAD_ERROR,
    CATALOG_CHANGE_SELECTED_SERVICE,
    CATALOG_ADD_CATALOG_SERVICE,
    CATALOG_DELETE_CATALOG_SERVICE,
    CATALOG_CHANGE_CATALOG_MODE,
    CATALOG_INITED,
    CATALOG_SET_LOADING,
    CATALOG_SAVING_SERVICE,
    CATALOG_CHANGE_TEXT,
    CATALOG_TEXT_SEARCH,
    CATALOG_ADD_LAYER_FROM_CATALOGS,

    LAYERDOWNLOAD_FORMAT_OPTIONS_FETCH,
    LAYERDOWNLOAD_FORMAT_OPTIONS_UPDATE,

    IDENTIFY_SET_LOADING,
    IDENTIFY_CHANGE_PAGE,
    IDENTIFY_NEW_REQUEST,
    IDENTIFY_PURGE_RESULTS,
    IDENTIFY_ERROR_FEATURE_INFO,
    IDENTIFY_EXCEPTIONS_FEATURE_INFO,
    IDENTIFY_LOAD_FEATURE_INFO,

    FEATURE_VIEWER_CLOSE,
    FEATURE_VIEWER_SET_LOADING,
    FEATURE_VIEWER_LOADED,
    FEATURE_VIEWER_LOAD_ERROR,

    FEEDBACKOPTIONS_INITIATE,
    FEEDBACKOPTIONS_FINISHED
};
